import React, {useRef, useState } from "react";
import { Canvas, extend } from "@react-three/fiber";
import { OrbitControls, Stars, Effects } from "@react-three/drei";

// My DataSet:
import universeRawData from "./data/universe.json";
import * as THREE from "three";

import { UnrealBloomPass } from "three-stdlib";
import { OutputPass } from "three/examples/jsm/postprocessing/OutputPass";
import GalaxySystem from "./GalaxySystem";
import GalaxyModalView from "./universeComponent/GalaxyModalView";
import Controllers from "./universeComponent/Controllers";
import { useStateValue } from "../utils/provider/StateProvider";
import NebulaSystems from "./systems/NebulaSystems";

extend({ UnrealBloomPass, OutputPass });

const MyObject = ({ props }) => {
  // Hide on basic of camera:

  const meshRef = useRef(null);
  // useFrame(({ camera }) => {
  //   // Access the z-coordinate of the object
  //   const objectZ = camera.position.z;

  //   // Set a threshold value for hiding the object
  //   const hideThreshold = 20;

  //   // Update visibility based on the z-coordinate
  //   if (objectZ > hideThreshold) {
  //     meshRef.current.visible = false;
  //   } else {
  //     meshRef.current.visible = true;
  //   }
  // });

  return (
    <group {...props} dispose={null}>
      <mesh ref={meshRef} position={[0, 0, 0]}>
        <sphereGeometry args={[1, 32, 32]} />
        <meshStandardMaterial
          color={"red"}
          emissive={"red"}
          emissiveIntensity={40}
          toneMapped={false}
        />
      </mesh>

      <Effects disableGamma>
        <unrealBloomPass threshold={1} strength={0.4} radius={0} />
        <outputPass args={[THREE.ACESFilmicToneMapping]} />
      </Effects>
    </group>
  );
};

function UniverseApp(props) {
  const [{showInfo, showSearchBar, showModals, locateMe}] = useStateValue();
  const canvasRef = useRef();
  const [universeData, setUniverseData] = useState(universeRawData);

  Object.keys(universeData).map((galaxy) => (
    console.log(galaxy)
  ))

  // Camera Refrences:
  let camera = new THREE.PerspectiveCamera(
    75, // Field of view in degrees
    window.innerWidth / window.innerHeight, // Aspect ratio
    1, // Near clipping plane
    100000000000000000000000000 // Far clipping plane
  );

  // Set the camera's position to view the object
  camera.position.set(-5, 2, -1); // Adjust the z-coordinate as needed


  // Change Galaxy view onClick:
  const [selectedGalaxy, setSelectedGalaxy] = useState("milkyway");

  const onChangeGalaxyView = (name, position) => {
    setSelectedGalaxy(name);
  };


  if(locateMe){
    camera.lookAt(-5, 2, -1)
  }

  return (
    <div className="space_canvas">
      <Canvas ref={canvasRef} camera={camera}>
        <OrbitControls minDistance={2} />
        <ambientLight intensity={0.8} />
        <pointLight position={[0, 0, 0]} intensity={1} />
        <Stars radius={1000000000000000} />
        <spotLight position={[-1.2, 0, 0]} angle={0.1} />

        {universeData &&
          Object.keys(universeData).map((galaxy) => (
            <group>
              {universeData[galaxy].data.category === "galaxy" &&
                <GalaxySystem
                  key={galaxy}
                  galaxy={universeData[galaxy]}
                  name={galaxy}
                  selectedGalaxy={selectedGalaxy}
                  viewGalaxy={selectedGalaxy}
                  onChangeGalaxyView={(name, position) =>
                    onChangeGalaxyView(name, position)
                  }
                />
              }

              {universeData[galaxy].data.category === "nebula" &&
                <NebulaSystems
                  key={galaxy}
                  galaxy={universeData[galaxy]}
                  name={galaxy}
                  selectedGalaxy={selectedGalaxy}
                  viewGalaxy={selectedGalaxy}
                  onChangeGalaxyView={(name, position) =>
                    onChangeGalaxyView(name, position)
                  }
                />
              }
            </group>
          ))}

      </Canvas>

      
      { showInfo && <GalaxyModalView id={selectedGalaxy} />}
      
      <Controllers />
    </div>
  );
}

export default UniverseApp;

// {
//     "milkyway":{
//         "data":{

//         },
//         "systems":{
//             "solar_system":{
//                 "parent":{},
//                 "bodies":{}
//             },

//             "other_system":{
//                 "parent": {},
//                 "bodies": {}
//             }
//         }
//     },

//     "andromeda":{
//         "data":{}
//     }
// }
